import {twMerge} from "tailwind-merge";

export default function SimpleCheckbox({checked = false, label = "", classes = {}, ...otherProps}) {

    const {parentClasses = ""} = classes;

    return (
        <label className={twMerge("group flex items-center cursor-pointer", parentClasses)}>
            <input
                className="peer hidden"
                type="checkbox"
                checked={checked}
                {...otherProps}/>
            <div className="w-6 h-6 min-w-[1.5rem] rounded-[0.313rem] flex-center ml-2.5 border border-pol-gray-light-3 bg-pol-light-7 group-hover:border-pol-blue duration-300">
                {
                    checked ?
                    <i className="icon-tick text-xs text-pol-dark" />
                    : null
                }
            </div>
            <p className="text-pol-dark">{label}</p>
        </label>
    )
}
